webpackJsonp([172546399187757],{

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-mla-1.e962ba50.jpg";

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-mla-2.67db00a9.jpg";

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-mla-3.58ba7522.jpg";

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-mla-4.aecd1377.jpg";

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Hero-mla.90fe3086.jpg";

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Inbox-mla.b3a0d82b.jpg";

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Mailmerge-mla.342d5a2f.jpg";

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Statistics-mla.a173b1bb.jpg";

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.MlaQuery = undefined;
	
	var _Grid = __webpack_require__(5);
	
	var _Hero = __webpack_require__(13);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _ProductBar = __webpack_require__(14);
	
	var _ProductBar2 = _interopRequireDefault(_ProductBar);
	
	var _ContentBlock = __webpack_require__(6);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _DividerImage = __webpack_require__(17);
	
	var _DividerImage2 = _interopRequireDefault(_DividerImage);
	
	var _HtmlContainer = __webpack_require__(8);
	
	var _HtmlContainer2 = _interopRequireDefault(_HtmlContainer);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _OrderButton = __webpack_require__(18);
	
	var _OrderButton2 = _interopRequireDefault(_OrderButton);
	
	var _PricingContainer = __webpack_require__(19);
	
	var _PricingContainer2 = _interopRequireDefault(_PricingContainer);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextSection = __webpack_require__(7);
	
	var _TextSection2 = _interopRequireDefault(_TextSection);
	
	var _reactJss = __webpack_require__(3);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _HeroMla = __webpack_require__(495);
	
	var _HeroMla2 = _interopRequireDefault(_HeroMla);
	
	var _InboxMla = __webpack_require__(499);
	
	var _InboxMla2 = _interopRequireDefault(_InboxMla);
	
	var _PhoneSecurity = __webpack_require__(40);
	
	var _PhoneSecurity2 = _interopRequireDefault(_PhoneSecurity);
	
	var _StatisticsMla = __webpack_require__(509);
	
	var _StatisticsMla2 = _interopRequireDefault(_StatisticsMla);
	
	var _MailmergeMla = __webpack_require__(502);
	
	var _MailmergeMla2 = _interopRequireDefault(_MailmergeMla);
	
	var _BackgroundMla = __webpack_require__(470);
	
	var _BackgroundMla2 = _interopRequireDefault(_BackgroundMla);
	
	var _BackgroundMla3 = __webpack_require__(471);
	
	var _BackgroundMla4 = _interopRequireDefault(_BackgroundMla3);
	
	var _BackgroundMla5 = __webpack_require__(472);
	
	var _BackgroundMla6 = _interopRequireDefault(_BackgroundMla5);
	
	var _BackgroundMla7 = __webpack_require__(473);
	
	var _BackgroundMla8 = _interopRequireDefault(_BackgroundMla7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    navcolour: {
	      backgroundColor: theme.colours.products.mla
	    },
	    text: {
	      width: "50vw",
	      "@media (max-width: 823px)": {
	        padding: 0,
	        width: "90%"
	      },
	      "& h1": {
	        fontSize: "5.4rem",
	        margin: 0,
	        textAlign: "center",
	        "@media (max-width: 823px)": {
	          fontSize: "3rem"
	        }
	      }
	    },
	    pricing: {
	      marginBottom: "5rem",
	      width: "35vw",
	      "@media (max-width: 823px)": {
	        marginBottom: "1rem",
	        textAlign: "center",
	        padding: 0,
	        width: "90%"
	      },
	      "& h1": {
	        fontSize: "5.4rem",
	        margin: 0,
	        textAlign: "center",
	        "@media (max-width: 823px)": {
	          fontSize: "3rem"
	        }
	      },
	      "& h2": {
	        fontSize: "2.2rem",
	        fontWeight: 100,
	        margin: 0,
	        textAlign: "center",
	        "@media (max-width: 823px)": {
	          fontSize: "2rem",
	          margin: 0,
	          padding: 0
	        }
	      }
	    },
	    pricingContainer: {
	      width: "100%"
	    },
	    contentBox: {
	      minHeight: "100vh"
	    },
	    image: {
	      width: "700px",
	      "@media (max-width: 823px)": {
	        display: "none"
	      }
	    },
	    mobileImage: {
	      width: "325px",
	      "@media (min-width: 824px)": {
	        display: "none"
	      }
	    },
	    noMobile: {
	      "@media (max-width: 823px)": {
	        display: "none"
	      }
	    },
	    mobile: {
	      margin: 0,
	      padding: 0,
	      "@media (min-width: 824px)": {
	        display: "none"
	      }
	    }
	  };
	};
	
	var NavTabs = [{
	  tabLink: "#features",
	  tabName: "Features"
	}, {
	  tabLink: "#pricing",
	  tabName: "Pricing"
	}, {
	  tabLink: "/tutorials",
	  tabName: "Tutorials"
	}, {
	  tabLink: "/faq",
	  tabName: "FAQ"
	}, {
	  tabLink: "/contact",
	  tabName: "Support"
	}];
	
	var MlaPage = function MlaPage(_ref) {
	  var classes = _ref.classes,
	      data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _ProductBar2.default,
	      {
	        className: classes.navcolour,
	        logoLink: "/mla",
	        logoSrc: "/mla-logo.svg"
	      },
	      NavTabs.map(function (tab) {
	        return _react2.default.createElement(_ProductBar.Tab, { key: tab.tabName, tabLink: tab.tabLink, tabName: tab.tabName });
	      })
	    ),
	    _react2.default.createElement(
	      _Hero2.default,
	      { hero: _HeroMla2.default, withBar: true },
	      _react2.default.createElement(
	        "div",
	        { className: classes.heroTextContainer },
	        _react2.default.createElement(
	          _Hero.HeroText,
	          null,
	          _react2.default.createElement(_Hero.HeroIcon, { src: "/northern-ireland-assembly.svg" }),
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.HeroText.html })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox, id: "features" },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.text },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.FirstContentSection.html })
	        ),
	        _react2.default.createElement(_Image2.default, { image: _InboxMla2.default, className: classes.image }),
	        _react2.default.createElement(_Image2.default, { image: _InboxMla2.default, className: classes.mobileImage })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundMla2.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.text },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentSection.html })
	        ),
	        _react2.default.createElement(_Image2.default, { image: _PhoneSecurity2.default, className: classes.image }),
	        _react2.default.createElement(_Image2.default, { image: _PhoneSecurity2.default, className: classes.mobileImage })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundMla4.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.text },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.ThirdContentSection.html })
	        ),
	        _react2.default.createElement(_Image2.default, { image: _StatisticsMla2.default, className: classes.image }),
	        _react2.default.createElement(_Image2.default, { image: _StatisticsMla2.default, className: classes.mobileImage })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundMla6.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.text },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.FourthContentSection.html })
	        ),
	        _react2.default.createElement(_Image2.default, { image: _MailmergeMla2.default, className: classes.image }),
	        _react2.default.createElement(_Image2.default, { image: _MailmergeMla2.default, className: classes.mobileImage })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundMla8.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox, id: "pricing" },
	      _react2.default.createElement(
	        "div",
	        { className: classes.pricingContainer },
	        _react2.default.createElement(
	          _Grid.Col,
	          { middle: true, center: true },
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.pricing },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.PricingSection.html })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.noMobile },
	          _react2.default.createElement(
	            _PricingContainer2.default,
	            null,
	            _react2.default.createElement(
	              _Grid.Row,
	              { center: true },
	              _react2.default.createElement(_HtmlContainer2.default, { content: data.FirstPricingChecklist.html }),
	              _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondPricingChecklist.html })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.mobile },
	          _react2.default.createElement(
	            _PricingContainer2.default,
	            null,
	            _react2.default.createElement(
	              _Grid.Col,
	              { start: true },
	              _react2.default.createElement(_HtmlContainer2.default, { content: data.FirstPricingChecklist.html }),
	              _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondPricingChecklist.html })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.Col,
	          { middle: true, center: true },
	          _react2.default.createElement(_OrderButton2.default, {
	            eventlabel: "Clicked MLA buy button",
	            mailinfo: "mailto:sales@electedtechnologies.com?subject=Caseworker.mla Sales Enquiry",
	            label: "Order Caseworker Now",
	            phonenumber: "0333 344 1225"
	          })
	        )
	      )
	    )
	  );
	};
	
	MlaPage.propTypes = {
	  classes: _propTypes2.default.object,
	  data: _propTypes2.default.object
	};
	
	exports.default = (0, _reactJss2.default)(styles)(MlaPage);
	
	/* global graphql */
	
	var MlaQuery = exports.MlaQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-mla-jsx-95688dc5bc638148f7fe.js